// extracted by mini-css-extract-plugin
export default {"menuToggle":"MenuMobil_menuToggle__sSDeQ","menu":"MenuMobil_menu__+bwnS"};